import {constants} from '../../constants';

export const setUpdateSate = (sate) => {
    return {type: constants.IS_UPDATE_STATE, payload: sate};
};
